import moment from 'moment';
import {
  loopbackPost,
  loopbackGet,
  loopbackPatch,
  LoopbackFilter,
  loopbackDelete,
} from '..';

import {
  AssignedReview,
  UserTokenData,
  UserRegistrationData,
  QuipUserWithInstitute,
  QuipUser,
  Enrollment,
  UserCertificateRequest,
} from '../../redux/types';

import { constructQueryParams } from './apiUtil';

export const login = (email: string, password: string): Promise<UserTokenData> => loopbackPost('QuipUsers/login', { email, password });

export const logout = (silentMode?: boolean): Promise<void> => loopbackPost('quipusers/logout', {});

export const changePassword = (oldPassword: string, newPassword: string): Promise<void> => loopbackPost('QuipUsers/change-password', { oldPassword, newPassword });

export const registerUser = (userInfo: UserRegistrationData): Promise<void> => loopbackPost('QuipUsers', {
  ...userInfo,
  registrationdate: moment.utc(),
});

export const getUsersWithInstitute = (): Promise<QuipUserWithInstitute[]> => {
  const filter = {
    include: 'institute',
  };
  return loopbackGet(`QuipUsers/?filter=${encodeURIComponent(JSON.stringify(filter))}`);
};

export const getUserWithInstitute = (userId: number): Promise<QuipUserWithInstitute> => loopbackGet(`QuipUsers/${userId}/withInstitute`);

export const getUsers = (): Promise<QuipUser[]> => loopbackGet('QuipUsers');

export const findUsersByEmails = (emails: string[]): Promise<QuipUserWithInstitute[]> => loopbackPost('QuipUsers/findByEmails', emails);

export const getUser = (userId: number): Promise<QuipUser> => loopbackGet(`QuipUsers/${userId}`);

export const updateUserInstitute = (userId: number, instituteId: number): Promise<QuipUser> => loopbackPost(`QuipUsers/${userId}/updateInstitute`, { instituteId });

export const updateUser = async (userData: QuipUser): Promise<QuipUser> => loopbackPatch(`QuipUsers/${userData.id}`, userData);

export const getReviewers = (): Promise<QuipUser[]> => loopbackGet('QuipUsers/reviewers');

export const getAssignedReviews = (userId: number, locale?: string): Promise<AssignedReview[]> => {
  // const uri = `quipusers/${userId}/assignedReviews${locale ? `?locale=${locale}` : ''}`;
  const uri = `QuipUsers/${userId}/assignedReviews`;
  return loopbackGet(uri);
};

export const getUsersEnrollments = (userId: number): Promise<Enrollment[]> => {
  const filter = { where: { attendeeId: userId, instituteId: null } };
  return loopbackGet(`QuipUsers/${userId}/enrollments?filter=${encodeURIComponent(JSON.stringify(filter))}`);
};

export const getUserCertificates = (
  userId: number, filter?: LoopbackFilter, query?: string,
): Promise<UserCertificateRequest[]> => {
  const queryParams = constructQueryParams(filter, query);
  const uri = `QuipUsers/${userId}/getCertificates${queryParams}`;
  return loopbackGet(uri);
};

export const exportUsers = (): Promise<string[][]> => loopbackGet('QuipUsers/exportUsers');

export const resetPassword = (newPassword: string, token: string): Promise<void> => loopbackPost(`QuipUsers/reset-password/?access_token=${token}`, { newPassword });

export const resendVerification = (email: string): Promise<void> => loopbackPost('QuipUsers/resendActivation', { email });

export const deleteUser = async (id: number): Promise<void> => loopbackDelete(`QuipUsers/${id}`);

export const declareReviewer = (user: QuipUser): Promise<void> => loopbackPost(`QuipUsers/${user.id}/setReviewer?value=true`);

export const undeclareReviewer = (user: QuipUser): Promise<void> => loopbackPost(`QuipUsers/${user.id}/setReviewer?value=false`);

export const resetUserEmail = (user: QuipUser, newEmail: string): Promise<void> => loopbackPatch(`QuipUsers/${user.id}`, { email: newEmail });
